<template>
  <div
    class="d-flex-row space-between align-start"
    v-if="checkoutStore.getSelectedDungeons.length > 0"
  >
    <p class="t-grey font-family-2 regular-l white-space-no">
      {{ $t("new.checkout.selected_dungeon") }}
    </p>
    <div class="d-flex-column flex-7">
      <p
        class="t-white font-family-2 bold-l"
        style="text-align: right"
        v-for="dungeon in checkoutStore.getSelectedDungeons"
        :key="dungeon"
      >
        {{ dungeon.numberOfDungeons }} -
        {{ dungeon.title }}
      </p>
    </div>
  </div>
  <div class="d-flex-row space-between" v-if="checkoutStore.getArmorType">
    <p class="t-grey font-family-2 regular-l">
      {{ $t("new.checkout.armor_type") }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ checkoutStore.getArmorType }}
    </p>
  </div>
  <div
    class="d-flex-row space-between"
    v-if="checkoutStore.getDetails?.difficultyId"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("new.checkout.difficulty") }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ selectedDifficulty?.title }}
    </p>
  </div>
  <!-- <div class="d-flex-row space-between" v-if="checkoutStore.getSelectedRaid?.id">
        <p class="t-grey font-family-2 regular-l">
            {{ $t("new.checkout.time") }}
        </p>
        <p class="t-white font-family-2 bold-l">
            {{ convertToCet(checkoutStore.getSelectedRaid?.date) }}
        </p>
    </div> -->
  <div
    class="d-flex-row space-between"
    v-if="checkoutStore.getSelectedRaid?.id"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ $t("new.checkout.loot") }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ checkoutStore.getSelectedRaid?.loot }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    selectedDifficulty() {
      if (this.checkoutStore.getDetails?.difficultyId) {
        return this.getGamePack?.prices?.find(
          (price) => price.id === this.checkoutStore.getDetails?.difficultyId
        );
      }
      return "";
    },
  },
  setup() {
    const { getGame, getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    const { getUserCurrencyCode } = useUserStore();
    return {
      getGame,
      getGamePack,
      checkoutStore,
      getUserCurrencyCode,
    };
  },
};
</script>
